import { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import ValidationMessage from '../../constants/ValidationMessage';
import Button from '../../components/ui/Button';
import useMakeRequest from '../../utils/ApiHelper';
import { ApiConstants } from '../../constants/ApiConstants';
import toast from 'react-hot-toast';
import { Routes } from '../../constants/RouteConstants';
import ReactSelect from 'react-select';
import { ApiTypes, LOCATION_TYPES } from '../../constants/Constants';
import PageLoader from '../../components/layouts/PageLoader';
import TopHeader from '../../components/layouts/TopHeader';
import { Tooltip as ReactTooltip } from "react-tooltip";
import authContext from '../../context/authContext';
import CustomInput from '../../components/ui/CustomInput';
import CustomReactSelect from '../../components/ui/CustomReactSelect';
import CustomRadioWithTooltip from '../../components/ui/CustomRadioWithTooltip';
import CustomModal from '../../components/layouts/CustomModal';
import PageLayout from '../../components/ui/PageLayout';


interface householdInputs {
    name: string;
    country: object | null,
    state: object | null,
    locality: object | null,
    billing_date: any
};

const HouseHoldValidation: any = yup.object().shape({
    name: yup.string().required(ValidationMessage.Field("a household name"))
        .min(3, ValidationMessage?.MinLength("The household name", 3))
        .max(25, ValidationMessage?.MaxLength("The household name", 25)),

    country: yup.object().required(ValidationMessage.SelectField("a country")),
    state: yup.object().required(ValidationMessage.SelectField("a state")),
    locality: yup.object().required(ValidationMessage.SelectField("a locality")),
});

const EditHousehold = () => {
    let profile: any = useContext(authContext);


    const navigate = useNavigate()
    const hhDetails = useMakeRequest()
    console.log("hhDetails: ", hhDetails)
    const AddHousehold = useMakeRequest()
    const countries = useMakeRequest();
    const localities = useMakeRequest();
    const states = useMakeRequest();
    const [selected, setSelected] = useState('task_based');
    const [submitForm, setSubmitForm]: any = useState(null)
    const [initialBillingDate, setInitialBillingDate] = useState<any>(null);
    const [showBillingChangeModal, setShowBillingChangeModal] = useState(false);
    const [showLocalityModal, setShowLocalityModal] = useState(false);

    const billinDateOptions = Array.from({ length: 31 }, (_, i) => ({
        label: (i + 1).toString(),
        value: i + 1,
    }));

    const { register, watch, setValue, formState: { errors }, handleSubmit, trigger } = useForm<householdInputs>({
        mode: 'onChange', resolver: yupResolver(HouseHoldValidation) as any
    });

    useEffect(() => {
        const currentBillingDate = watch("billing_date")?.value;
        if (
            currentBillingDate &&
            Number(currentBillingDate) !== Number(initialBillingDate)
        ) {
            setShowBillingChangeModal(true);
        }
    }, [watch("billing_date"), initialBillingDate]);

    const onSubmit = (form: any) => {
        const payload = {
            ...form,
            billing_date: form?.billing_date?.value,
            country: form?.country?.value,
            state: form?.state?.value,
            locality: form?.locality?.value,
            task_pricing_type: selected
        };
        setSubmitForm(payload);

        const previousLocalityId = Number(
            hhDetails?.data?.data?.locality_detail?.value ??
            hhDetails?.data?.data?.locality
        );

        const currentLocalityId = Number(form?.locality?.value);

        const isLocalityChanged = previousLocalityId !== currentLocalityId;


        if (isLocalityChanged) {
            setShowLocalityModal(true)
            // const modal: any = $('#editHouseholdModal');
            // modal.modal('show');
        } else {
            confirmSubmit(payload);
        }
    };


    const confirmSubmit = (payload: any = null) => {
        toast.promise(
            AddHousehold.makeRequest({ payload: payload || submitForm, url: ApiConstants?.UpdateHousehold }),
            {
                loading: 'Processing...',
                success: (data: any) => data.message,
                error: (error: any) => error.message,
            }
        );
        setShowLocalityModal(false)
    }

    useEffect(() => {
        if (AddHousehold?.status) {
            setTimeout(() => {
                profile.makeRequest({ url: ApiConstants?.Profile, type: ApiTypes?.GET })
                navigate(Routes?.ManageHousehold)
            }, 1000);
        }
    }, [AddHousehold?.status])

    useEffect(() => {
        countries.makeRequest({ url: ApiConstants?.LocationGet, payload: { type: LOCATION_TYPES?.COUNTRY, showAll: true } })
        hhDetails.makeRequest({ url: ApiConstants?.GetHouseholdDetails })
    }, [])

    useEffect(() => {
        if (hhDetails?.status) {
            console.log("hhDetails: ", hhDetails)
            setValue('name', hhDetails?.data?.data?.name)
            setValue('country', hhDetails?.data?.data?.country_detail)
            setValue('state', hhDetails?.data?.data?.state_detail)
            setValue('locality', hhDetails?.data?.data?.locality_detail)
            setValue('billing_date', { value: hhDetails?.data?.data?.billing_date, label: hhDetails?.data?.data?.billing_date })
            setInitialBillingDate(hhDetails?.data?.data?.billing_date);
            hhDetails?.data?.data?.task_pricing_type !== "none" && setSelected(hhDetails?.data?.data?.task_pricing_type)
            states.makeRequest({ url: ApiConstants?.LocationGet, payload: { type: LOCATION_TYPES?.STATE, list_id: hhDetails?.data?.data?.country, showAll: true } })
            localities.makeRequest({ url: ApiConstants?.LocationGet, payload: { type: LOCATION_TYPES?.LOCALITY, list_id: hhDetails?.data?.data?.state, showAll: true } })
        }
    }, [hhDetails?.status])

    return (
        <PageLayout headerName={"Edit Household"} onlyTitle={false}>
            <div className="">
                {hhDetails?.loading ? <PageLoader /> : ''}
                {/* <TopHeader headerName='Edit Household' /> */}
                <div className=''>
                    <form onSubmit={handleSubmit(onSubmit)} className='page-padding-x'>
                        <div className="auth-form">
                            <div className="auth-form-fields mb-3">


                                <CustomInput
                                    label="Household Name"
                                    type="text"
                                    placeholder="Enter name"
                                    required
                                    {...register('name')}
                                    error={errors.name?.message}
                                />

                                <CustomReactSelect
                                    label="Country"
                                    required
                                    options={countries?.data?.data}
                                    value={watch('country')}
                                    placeholder="Please select household name"
                                    onChange={(selectedOption: any) => {
                                        setValue("country", selectedOption);
                                        setValue("state", null);
                                        setValue("locality", null);
                                        trigger("country")
                                    }}
                                    isLoading={countries?.loading}
                                    error={errors}
                                    errorName="country"
                                    closeMenuOnScroll={true}
                                    closeMenuOnSelect={true}
                                />

                                <CustomReactSelect
                                    label="State"
                                    required
                                    options={states?.data?.data}
                                    defaultValue={profile?.data?.state_detail}
                                    value={watch('state')}
                                    placeholder="Select state"
                                    onChange={(selectedOption: any) => {
                                        setValue("state", selectedOption);
                                        setValue("locality", null);
                                        trigger("state")
                                        localities.makeRequest({ url: ApiConstants?.LocationGet, payload: { type: 3, list_id: selectedOption?.value, showAll: true } })
                                    }}
                                    isLoading={states?.loading}
                                    error={errors}
                                    errorName="state"
                                    closeMenuOnScroll={true}
                                    closeMenuOnSelect={true}
                                />

                                <CustomReactSelect
                                    label="Locality"
                                    required
                                    options={localities?.data?.data}
                                    defaultValue={profile?.data?.locality_detail}
                                    value={watch('locality')}
                                    placeholder="Select locality"
                                    onChange={(selectedOption: any) => {
                                        setValue("locality", selectedOption);
                                        trigger("locality")
                                    }}
                                    isLoading={localities?.loading}
                                    closeMenuOnScroll={true}
                                    closeMenuOnSelect={true}
                                    error={errors}
                                    errorName="locality"
                                />

                                <CustomReactSelect
                                    label="Budget Period Start Date"
                                    options={billinDateOptions as any}
                                    value={watch('billing_date')}
                                    className="com-r-select"
                                    classNamePrefix="com-r-select"
                                    placeholder="Select Billing Cycle Date"
                                    onChange={(selectedOption: any) => {
                                        setValue("billing_date", selectedOption);
                                        trigger("billing_date")
                                    }}
                                    closeMenuOnScroll={true}
                                    closeMenuOnSelect={true}
                                    menuPosition="fixed"
                                    menuShouldScrollIntoView={false}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                    }}
                                />
                            </div>
                            {[
                                {
                                    title: "Task-based pricing",
                                    type: "task_based",
                                    tooltipText:
                                        "Task-based pricing",
                                },
                                {
                                    title: "Task-neutral pricing",
                                    type: "task_neutral",
                                    tooltipText:
                                        "Task-neutral pricing",
                                },
                            ].map((pricing) => (
                                <CustomRadioWithTooltip
                                    id={pricing?.type}
                                    name="divisionRadio"
                                    value={pricing?.type}
                                    label={pricing?.title}
                                    tooltipText={pricing?.tooltipText}
                                    checked={pricing?.type === selected}
                                    onChange={setSelected}
                                />
                            ))}
                            <Button text='Continue' type='submit' className='com-btn my-5' loading={AddHousehold?.loading}>Continue</Button>
                        </div>
                    </form>
                </div>

                {showLocalityModal &&
                    <CustomModal
                        title='Changing the Locality'
                        title2='Please ensure that all chores and expenses are up-to-date before the locality is changed. Once the locality is changed, all chores entered on or after the date and time of the change will be calculated at the rate of the new locality. If you change the locality today and afterwards add chores from prior dates, such chores will be charged at the national rate.'
                        onConfirm={() => {
                            confirmSubmit()
                        }}
                        toggleModal={() => setShowLocalityModal(false)}
                    />
                }
                {showBillingChangeModal &&
                    <CustomModal
                        title='Updating Your Budget Period'
                        title2='The next budget period may be shorter or longer than 30 days to adjust for the new start date. In the following month, your budget period will begin on your new start date.'
                        buttonTxt="Continue"
                        showCancel={false}
                        onConfirm={() => {
                            setShowBillingChangeModal(false);
                            setInitialBillingDate(submitForm?.billing_date || watch("billing_date")?.value);
                        }}
                        toggleModal={() => setShowBillingChangeModal(false)}
                    />
                }

            </div>
        </PageLayout>
    )
}

export default EditHousehold